import React, {useContext, useEffect, useState} from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    FormControlLabel,
    Grid,
    Link,
    List,
    ListItem,
    Switch,
    Typography
} from '@deere/fuel-react';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {
    AE_SCHEDULE,
    QUICKLINKS,
    AE_ANNOUNCEMENTS,
    AE_ANNOUNCEMENTS_INTERNAL,
    AE_ANNOUNCEMENTS_EXTERNAL,
    RATINGS_OPEN,
    RATINGS_DUE,
    RATINGS,
    VIEW_CALENDAR,
    DUE_TOMORROW,
    DUE_TODAY,
    PAST_DUE
} from "../shared/Constants";
import LaunchIcon from "@material-ui/icons/Launch";
import {useAuthConfig} from '../shared/helper';
import {Chip} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorIcon from '@material-ui/icons/Error';
import {HomeAnnouncement} from "./HomeAnnouncement";
import {UserContext} from "./Main";
import {MultiUseModal} from "../shared/modal/MultiUseModal";
import Stack from "@mui/material/Stack";
import {validateEmbeddedLinks, validateLink} from "../shared/utils";
import {EditQuickLink} from "../shared/modal/modalComponents/EditQuickLink";
import {EditAnnouncement} from "../shared/modal/modalComponents/EditAnnouncement";
import {DeleteQuickLink} from "../shared/modal/modalComponents/DeleteQuickLink";
import {DeleteAnnouncement} from "../shared/modal/modalComponents/DeleteAnnouncement";
import {EditCalendar} from "../shared/modal/modalComponents/EditCalendar";

export const HomeView = ({name}) => {
    const initState = {
        currentFiscalYear: "",
        nextFiscalYear: "",
        calendarYearEndRatingsOpen: "",
        calendarYearEndRatingsDue: "",
        periodName: ""
    }
    let authAxios = useAuthConfig();
    const userContext = useContext(UserContext);
    const info = userContext;
    const [internalAnnouncements, setInternalAnnouncements] = useState([]);
    const [externalAnnouncements, setExternalAnnouncements] = useState([]);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedQuickLink, setSelectedQuickLink] = useState(null);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
    const [quickLinksLoading, setQuickLinksLoading] = useState(true);
    const [quickLinks, setQuickLinks] = useState([]);
    const isCriteriaAdmin = info && info.isCriteriaAdmin;
    const [noOfDaysLeft, setNoOfDaysLeft] = useState(15);
    const [alertBadgeLabel, setAlertBadgeLabel] = useState("");
    const [state, setState] = useState(initState);

    const getCurrentCalendarData = async () => {
        try {
            const res = await authAxios.get(`/calendar/current`);
            const data = res.data;
            processCalendarData(data);
        } catch (error) {
            console.log(error);
        }
    }

    const processCalendarData = data => {
        setState({
            ...state,
            calendarUrl: data.calendarUrl,
            currentFiscalYear: data.currentFiscalYear,
            nextFiscalYear: data.nextFiscalYear,
            calendarYearEndRatingsOpen: data.nextRatingPeriod[0].openDate,
            calendarYearEndRatingsDue: data.nextRatingPeriod[0].dueDate,
            periodName: data.nextRatingPeriod[0].period === 1 ? "Mid-Year" : "Year-End"
        })
        const noOfDaysInTime = new Date(new Date(data.nextRatingPeriod[0].dueDate).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0));
        const noOfDays = Math.round(noOfDaysInTime / (1000 * 3600 * 24));

        setNoOfDaysLeft(noOfDays)
        if (noOfDays <= 14 && noOfDays > 1)
            setAlertBadgeLabel(`${noOfDays} Days Left`)
        else if (noOfDays === 1)
            setAlertBadgeLabel(DUE_TOMORROW)
        else if (noOfDays === 0)
            setAlertBadgeLabel(DUE_TODAY)
        else if (noOfDays < 0)
            setAlertBadgeLabel(PAST_DUE)
    }

    const getCurrentAnnouncementData = async () => {
        try {
            const res = await authAxios.get(`/announcements/current`);
            const data = res.data;
            processAnnouncementData(data);
        } catch (error) {
            console.log(error);
        }
    }

    const processAnnouncementData = data => {
        if (data.length > 0) {
            setInternalAnnouncements(data.filter(announcement => announcement.announcementType === "internal"))
            setExternalAnnouncements(data.filter(announcement => announcement.announcementType === "external"))
        } else if (internalAnnouncements.some(announcement => announcement.id === data.id)) {
            setInternalAnnouncements(prevState =>
                prevState.map(announcement =>
                    announcement.id === data.id ? { ...announcement, ...data } : announcement
                )
            );
        } else if (externalAnnouncements.some(announcement => announcement.id === data.id)) {
            setExternalAnnouncements(prevState =>
                prevState.map(announcement =>
                    announcement.id === data.id ? { ...announcement, ...data } : announcement
                )
            );
        } else if (data.announcementType === "internal") {
            setInternalAnnouncements( prevState =>[...prevState, data]);
        } else if (data.announcementType === "external") {
            setExternalAnnouncements( prevState =>[...prevState, data]);
        }

    }

    const getCurrentQuickLinksData = async () => {
        try {
            const res = await authAxios.get(`/quick-links/current`);
            const data = res.data;
            processQuickLinksData(data);
        } catch (error) {
            console.log(error);
        }
    }

    const processQuickLinksData = data => {
        if (data.length > 0) {
            setQuickLinks(data)
            setQuickLinksLoading(false)
        } else if (quickLinks.some(link => link.id === data.id)) {
            setQuickLinks(prevState =>
                prevState.map(link =>
                    link.id === data.id ? { ...link, ...data } : link
                )
            );
        } else {
            setQuickLinks( prevState =>[...prevState, data])
        }
    }

    const postQuickLink = async (quickLink) => {
        let postQuickLinkJSON = {
            text: quickLink.text,
            url: quickLink.url,
            user: info.userId
        }
        try {
            const res = await authAxios.post(`/quick-links`, postQuickLinkJSON);
            processQuickLinksData(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    const putQuickLink = async (quickLink) => {
        let putQuickLinkJSON = {
            text: quickLink.text,
            url: quickLink.url.startsWith('http') ? quickLink.url : `http://${quickLink.url}`,
            user: info.userId
        }
        try {
            const res = await authAxios.put(`/quick-links/${quickLink.id}`, putQuickLinkJSON);
            processQuickLinksData(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    const deleteQuickLink = async (id) => {
        try {
            await authAxios.delete(`/quick-links/${id}`);
            setQuickLinks(prevState => prevState.filter(link => link.id !== id));
        } catch (error) {
            console.log(error);
        }
    }

    const postAnnouncement = async (announcement) => {
        let postAnnouncementJSON = {
            title: announcement.title,
            announcement: announcement.announcement,
            announcementType: announcement.announcementType,
            user: info.userId
        }
        try {
            const res = await authAxios.post(`/announcements`, postAnnouncementJSON);
            let newAnnouncement = res.data;
            newAnnouncement.timestamp = res.data.creationTs;
            processAnnouncementData(newAnnouncement);
        } catch (error) {
            console.log(error);
        }
    }

    const putAnnouncement = async (announcement) => {
        let putAnnouncementJSON = {
            title: announcement.title,
            announcement: announcement.announcement,
            announcementType: announcement.announcementType,
            user: info.userId
        }
        try {
            const res = await authAxios.put(`/announcements/${announcement.id}`, putAnnouncementJSON);
            processAnnouncementData(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    const deleteAnnouncement = async (id) => {
        try {
            await authAxios.delete(`/announcements/${id}`);
            setInternalAnnouncements(prevState => prevState.filter(announcement => announcement.id !== id));
            setExternalAnnouncements(prevState => prevState.filter(announcement => announcement.id !== id));
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getCurrentCalendarData();
        getCurrentAnnouncementData();
        getCurrentQuickLinksData();
        return () => {
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEditView = () => {
        userContext.setOnEditView(!userContext.onEditView)
    }

    const handleQuickLinkEdit = (id) => {
        const linkToEdit = quickLinks.find(link => link.id === id);
        setSelectedQuickLink(linkToEdit)
        setEditModalOpen(true);
    };

    const handleQuickLinkDelete = (id) => {
        setDeleteModalOpen(true);
        setSelectedQuickLink(quickLinks.find(link => link.id === id));
    }

    const handleCreateQuickLink = (id) => {
        setSelectedQuickLink({})
        setEditModalOpen(true);
    }

    const handleAnnouncementEdit = (id) => {
        const announcement = findAnnouncement(id);
        setSelectedAnnouncement(announcement)
        setEditModalOpen(true)
    }

    const handleCreateInternalAnnouncement = () => {
        setSelectedAnnouncement({announcementType: "internal", title: ""})
        setEditModalOpen(true)
    }

    const handleCreateExternalAnnouncement = () => {
        setSelectedAnnouncement({announcementType: "external", title: ""})
        setEditModalOpen(true)
    }

    const handleAnnouncementDelete = (id) => {
        const announcement = findAnnouncement(id);
        setDeleteModalOpen(true);
        setSelectedAnnouncement(announcement);
    }

    const handleEditNextFiscalYear = () => {
        setEditModalOpen(true);
    }

    const findAnnouncement = (id) => {
        return internalAnnouncements.find(announcement => announcement.id === id) ||
            externalAnnouncements.find(announcement => announcement.id === id);
    }

    const handleModalClose = () => {
        setDeleteModalOpen(false);
        setEditModalOpen(false);
        setSelectedQuickLink(null);
        setSelectedAnnouncement(null);
    }

    const onDeleteSubmit = async () => {
        if (selectedAnnouncement && selectedAnnouncement.id) {
            await deleteAnnouncement(selectedAnnouncement.id)
        } else {
            await deleteQuickLink(selectedQuickLink.id)
        }
        handleModalClose()
    }

    const onEditSubmit = async () => {
        if (selectedQuickLink && selectedQuickLink.text && validateLink(selectedQuickLink.url)) {
            if (selectedQuickLink.id) {
                await putQuickLink(selectedQuickLink);
            } else if (selectedQuickLink && selectedQuickLink) {
                await postQuickLink(selectedQuickLink);
            }
            handleModalClose()
        } else if (selectedAnnouncement && validateEmbeddedLinks(selectedAnnouncement.announcement)) {
            if (selectedAnnouncement.id) {
                await putAnnouncement(selectedAnnouncement);
            } else {
                await postAnnouncement(selectedAnnouncement);
            }
            handleModalClose()
        }
    }

    return (
        <>
            {deleteModalOpen && (
                <Stack maxHeight={0}>
                    <MultiUseModal
                        isOpen={deleteModalOpen}
                        modalTitle={selectedQuickLink ? "Delete Quick Link: " : "Delete Announcement: "}
                        onSubmit={onDeleteSubmit}
                        handleModalClose={handleModalClose}
                    >
                        {selectedQuickLink ? (
                            <DeleteQuickLink quickLink={selectedQuickLink} />
                        ) : (
                            <DeleteAnnouncement announcement={selectedAnnouncement} />
                        )}
                    </MultiUseModal>
                </Stack>
            )}
            {editModalOpen && (
                <Stack maxHeight={0}>
                    <MultiUseModal
                        isOpen={editModalOpen}
                        modalTitle={selectedQuickLink ? "Edit Link: " : (selectedAnnouncement ? "Edit Announcement: " : "Edit Next FY Calendar: ")}
                        onSubmit={onEditSubmit}
                        handleModalClose={handleModalClose}
                        hideActions={selectedQuickLink ? false : (selectedAnnouncement ? false : true)}
                    >
                        {selectedQuickLink ? (
                            <EditQuickLink
                                selectedQuickLink={selectedQuickLink}
                                setSelectedQuickLink={setSelectedQuickLink}
                            />
                        ) : ( selectedAnnouncement ? (
                            <EditAnnouncement
                                selectedAnnouncement={selectedAnnouncement}
                                setSelectedAnnouncement={setSelectedAnnouncement}
                            />
                        ) : (
                            <EditCalendar
                                onSubmit={onEditSubmit}
                                handleModalClose={handleModalClose}
                            />
                        ))}
                    </MultiUseModal>
                </Stack>
            )}
            <Grid container>
                <Grid item xs={6} className="sticky-header">
                    <Box padding={2}>
                        <Typography variant="h1" component="h1">{name}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} className="sticky-header">
                    <Box display="flex" justifyContent="flex-end">
                        {isCriteriaAdmin && (
                            <>
                                <Box padding={4}>
                                    <FormControlLabel
                                        control={<Switch
                                            name="Edit View"
                                            onChange={handleEditView}

                                        />}
                                        label="Edit View"
                                        style={{ marginRight: "0" }}
                                    />
                                </Box>
                            </>
                        )}
                    </Box>
                </Grid>
                <Grid item xs={4}>
                    <Box display="flex" flexDirection="column">
                        <Grid item xs={12}>
                            <Box p={2}>
                                <Card>
                                    <CardContent>
                                        <Grid container>
                                            <Grid item xs={6}>
                                                <Typography variant="h4">
                                                    {AE_SCHEDULE}
                                                </Typography>
                                                <Typography size="sm" color="secondary">
                                                    FY{state.currentFiscalYear} {state.periodName} {RATINGS}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Box display="flex" justifyContent="flex-end">
                                                    <Box display="flex" justifyContent="flex-end">
                                                        <LaunchIcon style={{
                                                            color: "#367c2b",
                                                            fontSize: '20px',
                                                            paddingRight: ".25rem"
                                                        }}/>
                                                        <Link href={state.calendarUrl} target="_blank" variant="h5"
                                                              style={{textDecoration: "none"}}
                                                              rel="noopener noreferrer">
                                                            {VIEW_CALENDAR}
                                                        </Link>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <List>
                                                    <ListItem divider style={{padding: ".5rem"}}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h4" display="inline"
                                                                        style={{paddingRight: ".25rem"}}>
                                                                {RATINGS_OPEN}:
                                                            </Typography>
                                                            <Typography display="inline" variant={"body1"}>
                                                                {state.calendarYearEndRatingsOpen}
                                                            </Typography>
                                                        </Grid>
                                                    </ListItem>
                                                    <ListItem style={{padding: ".5rem"}}>
                                                        <Grid item xs={8}>
                                                            <Box display="flex" justifyContent="flex-start">
                                                                <Typography variant="h4" display="inline"
                                                                            style={{paddingRight: ".25rem"}}>
                                                                    {RATINGS_DUE}:
                                                                </Typography>
                                                                <Typography display="inline" variant={"body1"}>
                                                                    {state.calendarYearEndRatingsDue}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <Box display="flex" justifyContent="flex-end">
                                                                {(noOfDaysLeft <= 14 && noOfDaysLeft >= 6) ?
                                                                    <Chip size="small"
                                                                          icon={<WarningIcon style={{fill: "#F99700"}}/>}
                                                                          label={alertBadgeLabel} style={{
                                                                        backgroundColor: "#fee7c4",
                                                                        fontWeight: 600,
                                                                        borderRadius: ".5rem"
                                                                    }}/>
                                                                    :
                                                                    <>
                                                                        {noOfDaysLeft <= 5 ?
                                                                            <Chip size="small"
                                                                                  icon={<ErrorIcon
                                                                                      style={{fill: "#C21020"}}/>}
                                                                                  label={alertBadgeLabel}
                                                                                  style={{
                                                                                      backgroundColor: "#F1C8CC",
                                                                                      fontWeight: 600,
                                                                                      borderRadius: ".5rem"
                                                                                  }}/>
                                                                            :
                                                                            <></>
                                                                        }
                                                                    </>
                                                                }
                                                            </Box>
                                                        </Grid>
                                                    </ListItem>
                                                    {userContext.onEditView && (
                                                        <Button onClick={() => handleEditNextFiscalYear()}>
                                                            Edit Calendar For Next Fiscal Year
                                                        </Button>
                                                    )}
                                                </List>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box p={2}>
                                <Card>
                                    <CardContent>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Typography variant="h4">{QUICKLINKS}</Typography>
                                                {!quickLinksLoading && (
                                                    <List>
                                                        {quickLinks.map((link, index) => (
                                                            <ListItem key={index} divider style={{padding: ".5rem"}}>
                                                                <Grid item xs={12}>
                                                                    <Link href={link.url} target="_blank" style={{fontSize: "16px"}}>
                                                                        {link.text}
                                                                    </Link>
                                                                </Grid>
                                                                {userContext.onEditView && (
                                                                    <>
                                                                        <Grid item xs={2}>
                                                                            <IconButton onClick={() => handleQuickLinkEdit(link.id)} aria-label="edit">
                                                                                <EditIcon/>
                                                                            </IconButton>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <IconButton onClick={() => handleQuickLinkDelete(link.id)} aria-label="delete">
                                                                                <DeleteIcon/>
                                                                            </IconButton>
                                                                        </Grid>
                                                                    </>
                                                                )}
                                                            </ListItem>
                                                        ))}
                                                        {userContext.onEditView && (
                                                            <Button onClick={() => handleCreateQuickLink()}>
                                                                Add New Link
                                                            </Button>
                                                        )}
                                                    </List>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Grid>
                    </Box>
                </Grid>
                {isCriteriaAdmin ?
                    <Grid item xs={8}>
                        <Box display="flex" flexDirection="column">
                            <Grid item xs={12}>
                                <Box p={2}>
                                    <HomeAnnouncement
                                        title={isCriteriaAdmin ? AE_ANNOUNCEMENTS_INTERNAL : AE_ANNOUNCEMENTS}
                                        announcements={internalAnnouncements}
                                        editable={userContext.onEditView}
                                        handleAnnouncementEdit={handleAnnouncementEdit}
                                        handleAnnouncementDelete={handleAnnouncementDelete}
                                        handleCreateInternalAnnouncement={handleCreateInternalAnnouncement}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box p={2}>
                                    <HomeAnnouncement
                                        title={isCriteriaAdmin ? AE_ANNOUNCEMENTS_EXTERNAL : AE_ANNOUNCEMENTS}
                                        announcements={externalAnnouncements}
                                        editable={userContext.onEditView}
                                        handleAnnouncementEdit={handleAnnouncementEdit}
                                        handleAnnouncementDelete={handleAnnouncementDelete}
                                        handleCreateExternalAnnouncement={handleCreateExternalAnnouncement}
                                    />
                                </Box>
                            </Grid>
                        </Box>
                    </Grid>
                    :
                    <>
                        {(info && info.isInternal) ?
                            <Grid item xs={8}>
                                <Grid item xs={12}>
                                    <Box p={2}>
                                        <HomeAnnouncement
                                            title={AE_ANNOUNCEMENTS}
                                            announcements={internalAnnouncements}
                                            editable={false}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                            :
                            <Grid item xs={8}>
                                <Grid item xs={12}>
                                    <Box p={2}>
                                        <HomeAnnouncement
                                            title={AE_ANNOUNCEMENTS}
                                            announcements={externalAnnouncements}
                                            editable={false}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        }
                    </>
                }
            </Grid>
        </>
    )
}
